/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit User/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function User({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info/User"
  
}) {
let smsVaxiomPersonOutboundPersonValueData = fromData.useDataFormat({ viewPath,
context: 'sms',
path: 'vaxiom_person_outbound.person',
format: fromFormat.personName,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 data="sms.vaxiom_person_outbound.person"
 format="/Data/format.js personName"
 whiteSpace="nowrap"
 maxWidth={120}
 marginRight={dtSpaceXs}
 text={smsVaxiomPersonOutboundPersonValueData}
/>
{children}
</React.Fragment>)
}